import { Club } from '@hefe/models';
import { ClubSlice } from '@hefe/store';
import { t } from '@hefe/i18n';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import CRUDComponent from '../../../crud/components/crud/crud.component';
import AddEditCustomUserAttributeForm from '../../forms/add-edit-custom-user-attribute/add-edit-custom-user-attribute.form';

interface ClubCustomUserAttributesProps {
  club: Club;
}

export default function ClubCustomUserAttributesComponent(
  props: ClubCustomUserAttributesProps
) {
  const dispatch = useAppDispatch();
  const [text, setText] = useState(props.club.welcome_text ?? '');
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);

  const userAttributes = useSelector(ClubSlice.customUserAttributesSelector);
  const userAttributeTypes = useSelector(
    ClubSlice.customUserAttributeTypesSelectSelector
  );

  useEffect(() => {
    fetchAttributes();
  }, []);

  const fetchAttributes = () => {
    setLoading(true);
    dispatch(ClubSlice.fetchClubCustomUserAttributes())
      .unwrap()
      .catch(() => null)
      .finally(() => setLoading(false));
  };

  const saveUserField = () => {
    setSaving(true);
    dispatch(
      ClubSlice.updateClubWelcomeText({
        welcome_text: text,
      })
    )
      .unwrap()
      .catch(() => null)
      .finally(() => setSaving(false));
  };
  return (
    <CRUDComponent
      table={{
        name: 'club-custom-user-fields',
        rowKey: 'id',
        loading: loading,
        hideColumnSelector: true,
        columns: [
          {
            key: 'name',
            title: t('name'),
            dataIndex: 'name',
            default: true,
          },
          {
            key: 'type',
            title: t('type'),
            dataIndex: 'type',
            default: true,
            render: (value) =>
              userAttributeTypes.find((type) => type.value === value)?.label,
          },
        ],
        dataSource: userAttributes,
        addForm: {
          formId: 'add-edit-custom-user-attribute-form-new',
          title: t('create'),
          component: <AddEditCustomUserAttributeForm />,
        },
      }}
      updateComponent={{
        formId: 'add-edit-custom-user-attribute-form',
        component: AddEditCustomUserAttributeForm,
        propKey: 'attribute',
        title: t('edit'),
      }}
      delete={{
        action: ClubSlice.deleteClubCustomUserAttribute,
        multiDelete: false,
      }}
    />
  );
}
